import aiimsLogo from '../assets/images/aiims.png';
import apolloLogo from '../assets/images/appolo.png';
import hospitalBg from '../assets/images/hospital-card-bg.jpg';

// Fortis reuses hospital-card-bg as placeholder until real logo is added
const fortisLogo = hospitalBg;

export const internationalHospitals = [
  { id: 1, logo: aiimsLogo,  name: 'AIIMS, New Delhi' },
  { id: 2, logo: fortisLogo, name: 'Fortis Heart Institute, Delhi' },
  { id: 3, logo: apolloLogo, name: 'Apollo Hospitals, Chennai' },
  { id: 4, logo: aiimsLogo,  name: 'AIIMS, New Delhi' },
  { id: 5, logo: fortisLogo, name: 'Fortis Heart Institute, Delhi' },
  { id: 6, logo: apolloLogo, name: 'Apollo Hospitals, Chennai' },
  { id: 7, logo: aiimsLogo,  name: 'AIIMS, New Delhi' },
  { id: 8, logo: fortisLogo, name: 'Fortis Heart Institute, Delhi' },
  { id: 9, logo: apolloLogo, name: 'Apollo Hospitals, Chennai' },
];
